import PropTypes from 'prop-types';
import React from 'react';

export const WAITLIST_TAB = 'waitlist';
export const ADD_ONS_TAB = 'addOns';

const tabStyle = (active) => ({
  padding: "8px 16px",
  marginBottom: "-2px",
  background: "none",
  border: "none",
  borderBottom: `2px solid ${active ? "var(--widget-tab-active-color, #FF595E)" : "transparent"}`,
  color: active ? "var(--widget-tab-active-color, #FF595E)" : "var(--widget-tab-inactive-color, var(--widget-font-color, #333))",
  display: "flex",
  alignItems: "center",
  gap: "6px",
  cursor: active ? "default" : "pointer"
});

const countStyle = (active) => ({
  background: active ? "var(--widget-tab-active-color, #FF595E)" : "#cccccc",
  color: active ? "#fff" : "#333",
  fontSize: "10.5px",
  fontWeight: 700,
  padding: "1px 7px",
  borderRadius: "12px"
});

const SoldOutTabs = ({ activeTab, waitlistEnabled, addOnCount, onWaitlistClick, onAddOnsClick }) => (
  <div>
    <div style={{ marginBottom: "12px" }}>
      <div style={{ fontSize: "18px", fontWeight: 700 }}>Sold out</div>
      <div style={{ color: "var(--widget-secondary-text-color, #686868)" }}>
        {waitlistEnabled
          ? "Join the waitlist, or shop what's still available."
          : "Shop what's still available."}
      </div>
    </div>
    <div role="tablist"
         style={{ display: "flex", borderBottom: "2px solid var(--widget-tab-border-color, #f0f0f0)", marginBottom: "20px" }}>
      <button type="button"
              role="tab"
              aria-selected={activeTab === WAITLIST_TAB}
              style={tabStyle(activeTab === WAITLIST_TAB)}
              onClick={activeTab === WAITLIST_TAB ? undefined : onWaitlistClick}>
        {waitlistEnabled ? "Waitlist" : "Tickets"}
      </button>
      <button type="button"
              role="tab"
              aria-selected={activeTab === ADD_ONS_TAB}
              style={tabStyle(activeTab === ADD_ONS_TAB)}
              onClick={activeTab === ADD_ONS_TAB ? undefined : onAddOnsClick}>
        Shop add-ons
        <span style={countStyle(activeTab === ADD_ONS_TAB)}>{addOnCount}</span>
      </button>
    </div>
  </div>
);

SoldOutTabs.propTypes = {
  activeTab: PropTypes.oneOf([WAITLIST_TAB, ADD_ONS_TAB]).isRequired,
  waitlistEnabled: PropTypes.bool,
  addOnCount: PropTypes.number.isRequired,
  onWaitlistClick: PropTypes.func,
  onAddOnsClick: PropTypes.func
};

export default SoldOutTabs;
